import EditCard from "./EditCard";
export default EditCard;
export type { EditCardProps } from "./EditCard";
